<template>
  <div class="login-container">
    <el-card class="box-card">
        <div class="logo-container">
            <img src="@/assets/logo-big.png" alt="Logo" class="logo-image">
        </div>
        <div class="slogan-container">
            <h2 class="slogan-text">做最专业的COD系统</h2>
        </div>
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          class="login-from"
        >
        <el-form-item prop="uname">
          <el-input v-model="ruleForm.uname" placeholder="请输入用户名">
            <template slot="prepend">
              <i class="el-icon-user"></i>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            type="password"
            v-model="ruleForm.password"
            autocomplete="off"
            placeholder="请输入密码"
          >
            <template slot="prepend">
              <i class="el-icon-lock"></i>
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <div class="btnGroup">
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          v-loading="loading"
          class="login-btn"
          >登录</el-button
        >
      </div>
    </el-card>
    <!-- 品牌标识 - 左下角 -->
    <div class="brand-container">
      <h2 class="brand-text">Jiuzhou-Africa</h2>
    </div>
  </div>
</template>

<script>
// 自定义 base64 解码函数，替代原生 atob
function base64Decode(str) {
  // 处理可能的填充问题
  str = String(str).replace(/=+$/, '');
  
  if (str.length % 4 === 1) {
    throw new Error('Invalid base64 string');
  }
  
  // 使用浏览器原生 atob 如果可用，否则使用替代实现
  if (typeof window !== 'undefined' && window.atob) {
    try {
      return window.atob(str);
    } catch (e) {
      // 如果原生 atob 失败，使用下面的替代实现
    }
  }
  
  // 纯 JavaScript 的 base64 解码实现
  const b64chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  let result = '';
  let bits = 0;
  let value = 0;
  
  for (let i = 0; i < str.length; i++) {
    const c = str.charAt(i);
    const idx = b64chars.indexOf(c);
    
    if (idx === -1) {
      throw new Error('Invalid base64 character: ' + c);
    }
    
    value = (value << 6) | idx;
    bits += 6;
    
    if (bits >= 8) {
      bits -= 8;
      result += String.fromCharCode((value >>> bits) & 0xFF);
    }
  }
  
  return result;
}

// 导入MD5加密函数
import { md5 } from '@/utils/md5.js';

export default {
  name: "Login",
  mounted() {
    // 页面加载时，检查是否有已登录用户
    let userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      // 如果有已登录用户，跳转到首页
      this.$router.push("/nav-bar");
    }
  },
  data() {
    return {
      ruleForm: {
        uname: "",
        password: "",
      },
      rules: {
        uname: [
          { required: true, message: "用户名不能为空！", trigger: "blur" },
        ],
        password: [
          { required: true, message: "密码不能为空！", trigger: "blur" },
        ],
      },
      loading: false, // 是否显示加载动画
    };
  },
  methods: {
    submitForm(formName) {
      // 验证表单中的账号密码是否有效，因为在上面rules中定义为了必填 required: true
      this.$refs[formName].validate((valid) => {
        // 点击登录后，让登录按钮开始转圈圈（展示加载动画）
        this.loading = true;
        // 如果经过校验，账号密码都不为空，则发送请求到后端登录接口
        if (valid) {
          let _this = this;
          // 使用 axios 将登录信息发送到后端
          this.axios({
            url: "/data-serv/user/sign-in",               // 请求地址
            method: "post",                       // 请求方法
            headers: {                            // 请求头
              "Content-Type": "application/json",
            },
            // 请求体，将登录信息以 JSON 字符串的形式发送到后端，密码进行MD5加密
            data: JSON.stringify({
              username: _this.ruleForm.uname,
              password: md5(_this.ruleForm.password), // 对密码进行MD5加密
            }),
          }).then((res) => { // 当收到后端的响应时执行该括号内的代码，res 为响应信息，也就是后端返回的信息
            if (res.data.code === 0) {  // 当响应的编码为 0 时，说明登录成功
              // 将用户信息存储到localStorage中
              localStorage.setItem("userInfo", JSON.stringify(res.data.data.userInfo));
              // 将 token 存储到localStorage中
              localStorage.setItem("token", res.data.data.token);
              // 跳转页面到首页
              this.$router.push('/nav-bar');
              // 显示后端响应的成功信息
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            } else {  // 当响应的编码不为 0 时，说明登录失败
              // 显示后端响应的失败信息
              this.$message({
                message: res.data.msg,
                type: "warning",
              });
            }
            // 不管响应成功还是失败，收到后端响应的消息后就不再让登录按钮显示加载动画了
            _this.loading = false;
            console.log(res);
          });
        } else {  // 如果账号或密码有一个没填，就直接提示必填，不向后端请求
          console.log("error submit!!");
          this.loading = false;
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style scoped>
/* 登录页面容器样式 */
.login-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('~@/assets/bg.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  overflow: hidden;
}

/* 为不同的宽高比优化背景显示 */
@media (orientation: landscape) and (max-height: 500px) {
  .login-container {
    background-size: 100vw auto;
  }
}

@media (orientation: portrait) {
  .login-container {
    background-size: auto 100vh;
  }
}

/* 超宽屏设备优化 */
@media (min-aspect-ratio: 16/9) {
  .login-container {
    background-size: cover;
  }
}

/* 设置登录面板居中，宽度为400px */
.box-card {
  margin: auto auto;
  width: 400px;
  padding: 1px 30px 40px 30px;
  background-color: rgba(255, 255, 255, 0.2) !important; /* 完全透明 */
  backdrop-filter: none;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 15px;
  box-shadow: none;
  transition: all 0.3s ease;
}


/* 设置登录面板中的表单居中 */
.login-from {
  margin: auto auto;
}

/* Logo 图片样式 */
.logo-container {
  text-align: center;
  margin-bottom: 0;
}

.logo-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
  object-fit: contain;
}

/* 标语样式 */
.slogan-container {
  text-align: center;
  margin-bottom: 15px;
  margin-top: 10px;
}

.slogan-text {
  color: #2c3e50;
  font-size: 20px;
  font-weight: 500;
  margin: 0;
  letter-spacing: 1px;
}

/* 标题样式 */
.box-card h2 {
  text-align: center;
  margin-bottom: 40px;
  color: #2c3e50;
  font-size: 28px;
  font-weight: 600;
  letter-spacing: 1px;
}

/* 按钮组样式 */
.btnGroup {
  margin-top: 30px;
}

.login-btn {
  width: 100%;
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 500;
}

/* 表单项目样式 */
.el-form-item {
  margin-bottom: 25px;
}

/* 输入框样式 */
.el-input {
  border-radius: 8px;
}

/* 按钮样式 */
.el-button {
  border-radius: 8px;
  padding: 12px 24px;
  font-weight: 500;
}

.el-button--primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%);
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .box-card {
    width: 90%;
    max-width: 400px;
    padding: 15px 20px 30px 20px;
  }
  
  .login-container {
    align-items: flex-start;
    padding-top: 5vh;
  }
  
  .slogan-text {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .login-container {
    background-size: cover;
    background-position: center center;
    padding-top: 0;
    align-items: center;
  }
  
  .box-card {
    width: 95%;
    padding: 10px 15px 25px 15px;
    margin: 20px auto;
  }
}

/* 品牌标识样式 */
.brand-container {
  position: absolute;
  bottom: 30px;
  left: 30px;
  z-index: 2;
}

.brand-text {
  font-size: 48px;
  font-weight: 300;
  color: #000000;
  margin: 0;
  text-shadow: 2px 2px 4px rgba(255, 255, 255, 0.5);
  letter-spacing: 1px;
}

@media (max-width: 480px) {
  .login-container {
    background-size: cover;
    background-position: center center;
  }
  
  .box-card {
    width: 95%;
    padding: 25px 15px;
    margin: 20px auto;
  }
  
  .brand-container {
    bottom: 20px;
    left: 20px;
  }
  
    .brand-text {
    font-size: 60px;
  }
  
  .slogan-text {
    font-size: 16px;
  }
}
</style>